import { JSX } from 'react';

import { Button, Text } from '@videoblocks/design-system';

export interface AiToolkitSidePanelActionsProps {
    label: string;
    credits: number;
    disabled?: boolean;
}

export const AiToolkitSidePanelActions = ({
    label,
    credits,
    disabled,
}: AiToolkitSidePanelActionsProps): JSX.Element => {
    return (
        <div className="w-full flex flex-col border-t dark:border-neutral-dark-200 py-4 px-3 gap-2">
            <div className="flex items-center gap-1">
                <div className="size-1 bg-yellow-500 rounded-full" />
                <Text fontSize="xs">{credits.toLocaleString()} Credits</Text>
            </div>
            <Button type="submit" disabled={disabled}>
                {label}
            </Button>
        </div>
    );
};
